import { gql } from '@apollo/client';
import {
    LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO,
    LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO_LIMITED
} from './fragments/location';

export const GET_PROJECT_LOCATIONS = gql`
    query GetProjectLocations($ProjectId: Int) {
        locations(data: { ProjectId: $ProjectId }) {
            LocationId
            Name
            Task {
                TaskId
                TaskStatus {
                    Name
                }
                TaskType {
                    TaskTypeId
                    Name
                    Abbr
                    TaskGroup
                }
                TaskResource {
                    TaskResourceId
                    Task {
                        TaskId
                    }
                    Machine {
                        MachineId
                        Name
                        SerialNbr
                        MachineType {
                            Name
                        }
                        MachineModel {
                            Name
                        }
                        MachineClass {
                            Name
                        }
                    }
                }
            }
            Point {
                x
                y
                z
            }
        }
    }
`;

export const GET_LOCATIONS = gql`
    query locations {
        locations {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const GET_LOCATIONS_BY_ID = gql`
    query locationsById(
        $WorkPackageId: Int
        $ProjectId: Int
        $EpicId: Int
        $WithTimeDrilled: Boolean! = true
    ) {
        locations(data: { WorkPackageId: $WorkPackageId, ProjectId: $ProjectId, EpicId: $EpicId }) {
            ...LocationFieldsWithPointsAndTaskInfoLimited
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO_LIMITED}
`;

export const CREATE_NEW_LOCATION_FOR_PROJECT_OR_WORKPACKAGE = gql`
    mutation createLocationForProjectOrWorkPackage(
        $LocationName: String!
        $TaskTypeIds: [Int!]
        $ProjectId: Int
        $WorkPackageId: Int
        $StartDate: Date
        $EndDate: Date
        $Points: [CreatePointInputType!]!
        $ResourceToAllMachines: Boolean
    ) {
        createLocation(
            data: {
                LocationName: $LocationName
                TaskTypeIds: $TaskTypeIds
                ProjectId: $ProjectId
                WorkPackageId: $WorkPackageId
                StartDate: $StartDate
                EndDate: $EndDate
                Points: $Points
                ResourceToAllMachines: $ResourceToAllMachines
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const CREATE_NEW_LOCATION = gql`
    mutation createLocation(
        $LocationName: String!
        $Points: [CreatePointInputType!]!
        $TaskTypeIds: [Int!]
        $StartDate: Date
        $EndDate: Date
    ) {
        createLocation(
            data: {
                LocationName: $LocationName
                Points: $Points
                TaskTypeIds: $TaskTypeIds
                StartDate: $StartDate
                EndDate: $EndDate
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const DELETE_LOCATION = gql`
    mutation deleteLocation($LocationId: Int!) {
        deleteLocation(data: { LocationId: $LocationId })
    }
`;

export const UPDATE_LOCATION_DATES = gql`
    mutation updateLocationDates($LocationId: Int!, $StartDate: Date, $EndDate: Date) {
        updateLocationDates(
            data: { LocationId: $LocationId, StartDate: $StartDate, EndDate: $EndDate }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const EDIT_LOCATION = gql`
    mutation editLocation(
        $LocationId: Int!
        $ProjectId: Int
        $Name: String
        $WorkPackageId: Int
        $CreateLocationRemarkText: [String!]
        $EditLocationRemark: [EditLocationUpdateLocationRemark!]
        $RemoveLocationRemarkIds: [Int!]
        $CreateTask: [EditLocationCreateTaskInputType!]
        $EditTask: [EditLocationUpdateTaskResource!]
        $Points: [UpsertPointInputType!]
    ) {
        editLocation(
            data: {
                LocationId: $LocationId
                ProjectId: $ProjectId
                Name: $Name
                WorkPackageId: $WorkPackageId
                CreateLocationRemarkText: $CreateLocationRemarkText
                EditLocationRemark: $EditLocationRemark
                RemoveLocationRemarkIds: $RemoveLocationRemarkIds
                CreateTask: $CreateTask
                EditTask: $EditTask
                Points: $Points
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const EDIT_LOCATION_MANY_LOCATIONS = gql`
    mutation editLocations(
        $ProjectId: Int
        $WorkPackageId: Int
        $Locations: [EditLocationsLocationInputType!]!
    ) {
        editLocations(
            data: { WorkPackageId: $WorkPackageId, ProjectId: $ProjectId, Locations: $Locations }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const UPDATE_LOCATION = gql`
    mutation updateLocation(
        $LocationId: Int!
        $LocationName: String!
        $Points: [UpsertPointInputType!]
        $AddTaskTypeIds: [Int!]
        $RemoveTaskIds: [Int!]
        $StartDate: Date
        $EndDate: Date
        $WorkPackageId: Int
        $ProjectId: Int
    ) {
        updateLocation(
            data: {
                LocationId: $LocationId
                Name: $LocationName
                AddTaskTypeIds: $AddTaskTypeIds
                RemoveTaskIds: $RemoveTaskIds
                Points: $Points
                StartDate: $StartDate
                EndDate: $EndDate
                ProjectId: $ProjectId
                WorkPackageId: $WorkPackageId
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;
